import { gql } from "apollo-boost"

export const GET_MINISTRATION_PLAN_AND_PERIOD_BY_SUBMISSION = gql`
  query GET_MINISTRATION_PLAN_AND_PERIOD_BY_SUBMISSION ($submissionId: ID!) {
    getMinistrationsPlanWithMinistrationsAndPeriodsBySubmission(submissionId: $submissionId) {
      id
      monthlyReviewDueDate
      finalReportDueDate
      ministrationPeriods {
        id
        orderIndex
        revisionDueDate
        revisionStartDate
        revisionEndDate
        ministrationDueDate
        ministrationStartDate
        ministrationEndDate
        ministration {
          id
          totalSaved
          paymentDate
          paymentAmount
          paymentBreakdown
          suppliedBreakdown
          savedBreakdown
          totalSupplied
          totalNoSupplied
          ministrationDocuments {
            id
            url
            name
            type
          }
          ministrationPaymentDocuments {
              id
              url
              name
              type
          }
        }
        ministrationBudget {
          id
          implementer
          alliedOne
          alliedTwo
          ficosec
        }
      }
    }
  }
`
